import { TypedDocumentNode, gql } from '@apollo/client';

import { Sport } from '__generated__/globalTypes';
import { unmaskFragment } from 'lib/graphql';

import { monetaryAmountFragment } from '../lib/monetaryAmount';
import {
  ReferralProgramConfigQuery,
  ReferralProgramConfigQueryVariables,
} from './__generated__/useReferralProgramConfig.graphql';
import { useQuery } from './graphql/useQuery';
import { useMonetaryAmount } from './useMonetaryAmount';

const REFERRAL_PROGRAM_CONFIG_QUERY = gql`
  query ReferralProgramConfigQuery($sport: Sport) {
    config {
      id
      referralProgramConfig(sport: $sport) {
        id
        maxDiscount {
          ...MonetaryAmountFragment_monetaryAmount
        }
      }
    }
  }
  ${monetaryAmountFragment}
` as TypedDocumentNode<
  ReferralProgramConfigQuery,
  ReferralProgramConfigQueryVariables
>;

export const useReferralProgramConfig = (sport: Sport) => {
  const { data } = useQuery(REFERRAL_PROGRAM_CONFIG_QUERY, {
    variables: { sport },
  });
  const { referralProgramConfig } = data?.config || {};
  const { toMonetaryAmount, getUserFiatAmountInMajorUnit } =
    useMonetaryAmount();

  return {
    referralProgramConfig,
    userFiatAmount: referralProgramConfig
      ? getUserFiatAmountInMajorUnit(
          toMonetaryAmount(unmaskFragment(referralProgramConfig.maxDiscount))
        )
      : undefined,
  };
};
